import Rails from '@rails/ujs';

document.addEventListener("turbolinks:load", () => {
  let paginationContainer = document.querySelector('.js-pagination-container');

  if (paginationContainer == null) { return }

  function setupInfiniteScroll(callback = null) {
    let viewMoreBtn = document.getElementById('js-view-more-tutors-btn');

    if (viewMoreBtn == null) { return }

    viewMoreBtn.addEventListener('click', function(event) {
      event.preventDefault();
      viewMoreBtn.disabled = true;
      viewMoreBtn.innerHTML = I18n.t('javascript.infinite_scroll.loading');
      getData();
    });

    function getData() {
      // tutorsTarget - target for inject next page
      var tutorsTarget = document.querySelector('.js-infinite-scroll');
      // paginationTarget - target for replace pagination
      let paginationTarget = document.querySelector('.pagination-link');
      let nextPage = document.querySelector("a[rel='next']");

      if (nextPage == null) { return }

      let url = nextPage.href;
      let currentScrollPosition = window.scrollY;

      Rails.ajax({
        type: 'GET',
        url: url,
        dataType: 'json',
        success: (data) => {
          tutorsTarget.insertAdjacentHTML('beforeend', data.entries);
          paginationTarget.innerHTML = data.pagination;

          nextPage = document.querySelector("a[rel='next']");
          if (nextPage == null) {
            viewMoreBtn.style.display = 'none';
          } else {
            viewMoreBtn.disabled = false;
            viewMoreBtn.innerHTML = I18n.t('javascript.infinite_scroll.see_more_tutors');
          }

          // Set the scroll position of the page to the saved value
          // Hack to prevent the page from jumping to the top
          window.scrollTo(0, currentScrollPosition);

          if (callback) {
            callback();
          }
        }
      });
    }
  }

  window.setupInfiniteScroll = setupInfiniteScroll;
  setupInfiniteScroll();

});
